// JS Plugins
import Rails from 'rails-ujs'

// Custom JS
import './utils'
import './progressive-loading-images'
import './custom-selects'
import './remote-forms'
import './show-password'
import './tooltip'

// Iamges & Syles
import './images';
import './stylesheets/app.scss';

// Init
Rails.start();



// WEBPACK FOOTER //
// app/javascript/common/index.js